function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
export function TriangleDown(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 10 8"
  }, props), React.createElement("path", {
    d: "M5 8l5-8H0z",
    fill: "#537DD4",
    fillRule: "evenodd"
  }));
}